import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { InsuranceService } from '../_services/insurance.services';
import { RequestService } from '../_services/request.services';
import { InterestService } from '../_services/interest.services';
import { exhaustMap, map } from 'rxjs/operators';
import { Policy } from '../_models/policy.model';
import { Document } from '../_models/document.model';
import { Interest } from '../_models/interest.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

declare var download: any;

import {
  GroupingState,
  PaginatorState,
  SortState,
  ICreateAction,
  IEditAction,
  IDeleteAction,
  IDeleteSelectedAction,
  IFetchSelectedAction,
  IUpdateStatusForSelectedAction,
  ISortView,
  IFilterView,
  IGroupingView,
  ISearchView,
} from '../../_metronic/shared/crud-table';

@Component({
  selector: 'app-list-request',
  templateUrl: './list-request.component.html',
  styleUrls: ['./list-request.component.scss']
})
export class ListRequestComponent
  implements
  OnInit, 
  OnDestroy {
    loadingModalConfig: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
    };
    loadingModal: boolean = false;
    paginator: PaginatorState;
    sorting: SortState;
    grouping: GroupingState;
    isLoading: boolean;
    templateView: number = 1;
    idPoliza: number = 0;
    idDocument: number = 0;
    idEntity: number = 0;
    insuredFilter: number = 0;
    policy_selected: Policy;
    document_selected: Document;
    documents_policy: Document[];
    interest_selected: Interest;
    showComapnyName: boolean = false;
    extrasUserDropdownStyle: 'light' | 'dark' = 'light';
    user$: Observable<UserModel>;
    _user: UserModel;
    hasError: boolean;
    ramos: any;
    subramos: any;
    anyos: any;
    meses: any;
    endosos: any;
    status: any;
    tiposEndosos: any;
    filterRequestForm: FormGroup;
    inputIdTipoEndoso: boolean;
    closeResult: string;
    activeSubmitFilterPolicy: boolean = false;
    IdRamo: boolean = false;
    templatePostEndoso: number = 1;
    resultPostEndosoMessage: string;
    requestDetail: any;
    private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  
    constructor(
      private layout: LayoutService,
      private auth: AuthService,
      private fb: FormBuilder,
      private modalRequest: NgbModal,
      private modalLoading: NgbModal,
      public sanitizer: DomSanitizer,
      public requestService: RequestService
    ) {}
  
    // angular lifecircle hooks
    async ngOnInit() {
      this.initForm();
  
      this.extrasUserDropdownStyle = this.layout.getProp(
        'extras.user.dropdown.style'
      );
      this.user$ = this.auth.currentUserSubject.asObservable();
      this.user$.subscribe(user=> {
        this._user = user;
       });
  
      this.requestService.fetch();
      this.paginator = this.requestService.paginator;
      this.endosos = this.requestService.getEndosos("");
      this.meses = this.requestService.getMeses();
      this.anyos = this.requestService.getAnyos();
      this.status = this.requestService.getStatus();

      const sb1 = this.requestService.isLoading$.subscribe(res => this.isLoading = res);
      this.subscriptions.push(sb1);
    }
  
    ngOnDestroy() {
      this.subscriptions.forEach((sb) => sb.unsubscribe());
    }
  
    async clickView(id = 0, _templateView) {
      var _this = this;
      if(!id){
        return false;
      }
      else {
        switch ((this.templateView = _templateView)) {
          case 1:
            this.templateView = _templateView;
            break;
          case 2:

            break;
        }
      }
    }

    initForm() {

      this.filterRequestForm = this.fb.group({
        inputIdTipoEndoso: [''],
        inputMes: [''],
        inputAnyo: [''],
        inputStatus: [''],
        inputNroDePoliza: ['']
      });
  
    }

    resetSubmitFilter() {
      this.filterRequestForm.reset( {"inputNroDePoliza" : ""} );

    }

    clickModalRequest(item, content) {
      this.loadingModal= true;
  
      this.modalRequest.open(content).result.then((result) => {
        console.log(result)
      }, (reason) => { // this.getDismissReason(reason)
          
      });
  
      console.log(this.requestDetail = item);
      this.loadingModal = false;
      /*
      this.interestService.extracData(id, this.interestService.items$).finally(() => {
        this.loadingModal = false;
      });    
      */
    }
  
    submitFilterRequest() {
      var paramsGet = "";

        paramsGet = Array( 
            `IdEntidad=${this._user.id}`,
            `IdTipoEndoso=${this.filterRequestForm.value.inputIdTipoEndoso ? this.filterRequestForm.value.inputIdTipoEndoso : 0}`,
            `IdEstatus=${this.filterRequestForm.value.inputStatus ? this.filterRequestForm.value.inputStatus : 0}`,
            `IdMes=${this.filterRequestForm.value.inputMes}`,
            `IdAno=${this.filterRequestForm.value.inputAnyo}`,
            `NroPoliza=${this.filterRequestForm.value.inputNroDePoliza}`,
        ).join('&');
  
      this.requestService.patchState({ paramsGet : paramsGet });

    }

}
